var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.template.type === "GROUP"
    ? _c("questionnaire-view-section-group", {
        attrs: {
          model: _vm.model,
          response: _vm.response,
          template: _vm.template,
        },
        on: { mounted: _vm.onSectionMounted },
      })
    : _vm.template.type === "TABLE"
    ? _c("questionnaire-view-section-table", {
        attrs: {
          config: _vm.config,
          globals: _vm.globals,
          model: _vm.model,
          response: _vm.response,
          template: _vm.template,
        },
        on: { mounted: _vm.onSectionMounted },
      })
    : _vm.template.type === "HOTEL_RFP_RATE_GRID"
    ? _c("questionnaire-hotel-rfp-rate-grid", {
        attrs: {
          config: _vm.config,
          globals: _vm.globals,
          model: _vm.model,
          response: _vm.response,
          template: _vm.template,
        },
        on: { mounted: _vm.onSectionMounted },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }